import React from 'react';

import HpPencil from 'shared-vectors/icons/HpPencil';
import { Icon } from 'shared-vectors';

export default (isMobile) => (
  <Icon
    aria-hidden="true"
    name={HpPencil}
    width={isMobile ? '16px' : '18px'}
    height={isMobile ? '16px' : '18px'}
    className="mb--xs"
    fill
  />
);
